// extracted by mini-css-extract-plugin
export var linkCardDisclaimerV1 = "LinkDisclaimer-module--linkCardDisclaimerV1--OuWY2";
export var linkCardDisclaimerV2 = "LinkDisclaimer-module--linkCardDisclaimerV2--N3rMv";
export var linkCardDisclaimerTitle = "LinkDisclaimer-module--linkCardDisclaimerTitle--spgQY";
export var linkCardDisclaimerText = "LinkDisclaimer-module--linkCardDisclaimerText--7wFsz";
export var linkCardDisclaimerButton = "LinkDisclaimer-module--linkCardDisclaimerButton--x3B0Q";